import { DriverTaxiDriverAssociationsData } from "../../../../../../../../common/services/driver/taxi-driver/associations/driver-taxi-driver-associations";
import DriverContractAddByRailyTaxiAssociationSelectOption from "../types/driver-contract-add-by-raily-taxi-association-select-option";

const createTaxiAssociationSelectOption = (
  responseTaxiAssociation: DriverTaxiDriverAssociationsData,
): DriverContractAddByRailyTaxiAssociationSelectOption => {
  return {
    label: responseTaxiAssociation.taxiCorporation.displayName,
    value: {
      uuid: responseTaxiAssociation.id,
    },
  };
};

const createTaxiAssociationSelectOptions = (
  responseTaxiAssociations: DriverTaxiDriverAssociationsData[],
): DriverContractAddByRailyTaxiAssociationSelectOption[] => {
  return responseTaxiAssociations.map(createTaxiAssociationSelectOption);
};

const driverContractAddByRailyFactory = {
  createTaxiAssociationSelectOptions,
};

export default driverContractAddByRailyFactory;
